import { DataGridLocaleTextColumn } from '@app/components/atoms/data-grid-locale-text-column'
import { ReviewForm } from '@app/components/forms/review-form'
import { Binding, DeleteEntityDialog, PersistButton } from '@app/lib/binding'
import { BackButton } from '@app/lib/buttons'
import {
	DataGrid,
	DataGridColumn,
	DataGridHasOneColumn,
	DataGridLoader,
	DataGridPagination,
	DataGridQueryFilter,
	DataGridTable,
	DataGridToolbar,
} from '@app/lib/datagrid'
import { ImageField } from '@app/lib/form'
import { Slots } from '@app/lib/layout'
import { Button } from '@app/lib/ui/button'
import { EntitySubTree, Link, RedirectOnPersist } from '@contember/interface'
import { TrashIcon } from 'lucide-react'
import { CopyPopover } from '@app/components/copier'

export const List = () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Review list</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<>
						<Slots.Actions>
							<Link to="review/create">
								<Button>Create review</Button>
							</Link>
						</Slots.Actions>
						<DataGrid entities="Review">
							<DataGridToolbar>
								<DataGridQueryFilter />
							</DataGridToolbar>
							<DataGridLoader>
								<DataGridTable>
									<DataGridColumn>
										<div className="flex gap-4">
											<Link to="review/edit(id: $entity.id)">
												<Button variant="outline">Edit</Button>
											</Link>
										</div>
									</DataGridColumn>
									<DataGridHasOneColumn field="avatar" header="Avatar">
										<ImageField urlField="url" small />
									</DataGridHasOneColumn>
									<DataGridLocaleTextColumn field="name" header="Name" />
									<DataGridLocaleTextColumn field="position" header="Position" />
									<DataGridColumn>
										<div className="flex justify-end items-center gap-4">
											<DeleteEntityDialog
												trigger={
													<Button variant="destructive" size="sm">
														<TrashIcon className="w-3 h-3" />
													</Button>
												}
											/>
										</div>
									</DataGridColumn>
								</DataGridTable>
							</DataGridLoader>
							<DataGridPagination />
						</DataGrid>
					</>
				</div>
			</Binding>
		</>
	)
}

export const Create = () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Review create</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<EntitySubTree entity="Review" isCreating>
						<RedirectOnPersist to="review/edit(id: $entity.id)" />
						<Slots.Actions>
							<CopyPopover />
							<PersistButton />
						</Slots.Actions>
						<ReviewForm />
					</EntitySubTree>
				</div>
			</Binding>
		</>
	)
}

export const Edit = () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Review edit</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<EntitySubTree entity="Review(id=$id)" isCreating={false}>
						<Slots.Actions>
							<CopyPopover />
							<PersistButton />
						</Slots.Actions>
						<ReviewForm />
					</EntitySubTree>
				</div>
			</Binding>
		</>
	)
}
